import { render, staticRenderFns } from "./material-add.vue?vue&type=template&id=f11e02e6&scoped=true"
import script from "./material-add.vue?vue&type=script&lang=js"
export * from "./material-add.vue?vue&type=script&lang=js"
import style0 from "./material-add.vue?vue&type=style&index=0&id=f11e02e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11e02e6",
  null
  
)

export default component.exports